import { OnboardingState } from './types';

export const setOnboardingComplete = (
  state: OnboardingState,
  isComplete: boolean,
): OnboardingState => ({
  ...state,
  isOnboardingComplete: isComplete,
});

export const setCurrentStep = (
  state: OnboardingState,
  step: number,
): OnboardingState => ({
  ...state,
  currentStep: step,
});

export const setLoading = (
  state: OnboardingState,
  isLoading: boolean,
): OnboardingState => ({
  ...state,
  isLoading,
});

export const nextStep = (state: OnboardingState): OnboardingState => ({
  ...state,
  currentStep: state.currentStep + 1,
});

export const previousStep = (state: OnboardingState): OnboardingState => ({
  ...state,
  currentStep: Math.max(0, state.currentStep - 1),
});

export const completeOnboarding = (
  state: OnboardingState,
): OnboardingState => ({
  ...state,
  isOnboardingComplete: true,
  currentStep: 0,
  isLoading: false,
});

export const resetOnboarding = (state: OnboardingState): OnboardingState => ({
  ...state,
  isOnboardingComplete: false,
  currentStep: 0,
  isLoading: false,
});
